<template>
  <div class="">
    <div class="w-full p-5 bg-white">
      <h2 class="text-xl mb-0 font-semibold">Connected Payment Gateway</h2>
    </div>
    <!-- <div class="py-4">
      <div class="grid grid-cols-3 gap-8 mt-4">
        <div class="p-4 elshadow rounded-12px bg-white">
          <div class="flex w-full justify-start mt-2">
            <div class="flex w-1/5 justify-center">
              <img
                src="https://nimbuscluster.blob.core.windows.net/server01/Admin/Payments/Image 1.png"
                class="pm-imgw"
              />
            </div>
            <div class="w-4/5 pl-2">
              <div class="flex justify-between items-center pr-4">
                <div class="flex gap-2 items-center">
                  <h3 class="text-lg font-semibold text-dark mb-0 pr-2">
                    Razorpay
                  </h3>
                  <el-tag
                    type="success"
                    class="elchips-py rounded-full px-4 py-1 fsize10"
                    >Active
                  </el-tag>
                </div>
                <div class="cursor-pointer">
                  <feather-icon
                    icon="TrashIcon"
                    class="text-gray"
                    svgClasses="w-5 h-5"
                  />
                </div>
              </div>
              <div class="mt-2">
                <div class="flex gap-2 items-center">
                  <p class="text-black mb-0 font-semibold fsize11">Provider:</p>
                  <p class="text-8f8f8f mb-0 font-normal fsize11">Razorpay</p>
                </div>
              </div>
              <div class="mt-1">
                <div class="flex gap-2 items-center">
                  <p class="text-black mb-0 font-semibold fsize11">Account:</p>
                  <p class="text-8f8f8f mb-0 font-normal fsize11">
                    admin@nhrdn.com
                  </p>
                </div>
              </div>
              <p
                class="text-primary fsize14 font-medium cursor-pointer mt-4 mb-0"
              >
                Manage Account
              </p>
              <Razorpay />
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="grid grid-cols-3 gap-8 my-8">
      <div class="w-full" v-for="gateway in paymentGateway" :key="gateway._id">
        <Gateway :gateway="gateway" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Gateway from "./Gateway.vue";

export default {
  components: {
    Gateway,
  },
  data() {
    return {
      // testAmount: 1,
    };
  },
  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    // ...mapState("payment", ["razorpay"]),
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("Payment", {
      paymentGateway: "paymentGateway",
    }),
  },

  methods: {
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    injectRazorpay() {
      let divScripts = document.getElementById("load-script");
      let newScript = document.createElement("script");
      newScript.src = "https://checkout.razorpay.com/v1/checkout.js";
      divScripts.appendChild(newScript);
      src / apolloClient.js;
    },
    async init() {
      let data = await this.$store.dispatch("Payment/getGateway");
      console.log(this.paymentGateway);
    },
  },
  mounted() {
    // this.injectRazorpay();
    this.init();
  },
};
</script>
